import ChartByConnector from "@/components/modules/ChartByConnector";
import cpReqConf from "./cp_requests";
import cpSessionConf from "./cp_sessions";
import CpConfigList from "@/views/custom/cp_config_list";
import RsrStartCharger from "@/views/crud/modules/RsrStartCharger";
import RsrStopCharger from "@/views/crud/modules/RsrStopCharger";
import RsrResetCharger from "@/views/crud/modules/RsrResetCharger";
// import ChangeAvailability from "@/views/custom/change_availability";
import UnlockCharger from "@/views/crud/modules/UnlockCharger";
import GetDiagnostics from "@/views/crud/modules/GetDiagnostics";
import ChangeAvailability from "@/views/crud/modules/ChangeAvailabilityCharger";
import BaseButton from "@/views/crud/modules/BaseButton";

export default {
  key: "cp",
  id: "cp_id",
  export: ["excel"],
  excel: {
     //max_row: "50000"
  },
  sort_fields: [
    "cp_id",
    "name",
    "cp_no",
    "loc_id",
    "loc_address",
    "firmware_version",
    "charging_status_code",
    "charging_status",
    "connectora_status",
    "connectorb_status",
    "last_status_dttm",
    "boot_dttm",
    "lupd_dttm",
    "power_meter_type_id",
    "min_power_threshold"
  ],
  filters: {
    cp_id: {},
    cp_no: {
      type: "multiselect",
      label: "cp_no",
      value: "cp_no",
      filterable: true
    },

    loc_id: {
      type: "select",
      label: "name_chi",
      value: "loc_id",
    },
    loc_address: {
      type: "multiselect",
      label: "loc_address",
      value: "loc_id",
    },
    power_meter_type_id: {
      type: "select",
      label: "name",
      value: "power_meter_type_id",
    },
    charging_status_code: {
      type: "multiselect",
      label: "name_chi",
      value: "charging_status_code",
    },
    charging_status: {
      type: "multiselect",
      label: "name_chi",
      value: "charging_status_code",
    },
    connectora_status: {
      type: "multiselect",
      label: "name_chi",
      value: "charging_status_code",
    },
    connectorb_status: {
      type: "multiselect",
      label: "name_chi",
      value: "charging_status_code",
    },
    firmware_version: {},
    enable_flag: {
      default: 1,
      type: "boolean"
    },
    name_chi: {},
    last_status_dttm: {
      type: "daterange"
    },
    boot_dttm: {
      type: "daterange"
    },
    lupd_dttm: {
      type: "daterange"
    },
  },
  fields: [
    { key: "cp_id", width: 75, disabled_by_column:true },
    { key: "cp_no", notfill: true, disabled_by_column:true },
    { key: "loc_address", disabled_by_column:true, hidden: ["create","edit","view"] },
    { key: "charge_box_serial_number", disabled_by_column:true },
    // { key: "cp_type", field: "cp_type.name",  value:"cp_type.id" ,type: "select"},
    { key: "charger_type", privilege: ["READ_CP_TYPE"], disabled_by_column:true},
    { key: "name_chi", disabled_by_column:true },
    { key: "loc_id", field: "loc_id.address", value: "loc_id.loc_id", type: "select" , hidden: ["list"], disabled_by_column:true },
    { key: "power_meter_type_id", field: "power_meter_type_id.name", value: "power_meter_type_id.power_meter_type_id", type: "select", hidden: ["list"], disabled_by_column:true },
    { key: "firmware_version", width: 95, disabled_by_column:true },
    { key: "charging_status_code", field: "charging_status_code.name_chi", hidden: ["list"], width: 100, disabled_by_column:true },
    { key: "charging_status", field: "charging_status", width: 100 },
    { key: "connectora_status", field: "connectora_status", width: 100 },
    { key: "connectorb_status", field: "connectorb_status", width: 100 },
    { key: "last_status_dttm", type: "datetime", disabled_by_column:true },
    { key: "boot_dttm", type: "datetime", disabled_by_column:true },
    { key: "lupd_dttm", type: "datetime", disabled_by_column:true },
    { key: "max_power_output", hidden: ["list"], disabled_by_column:true },
    { key: "heartbeat_interval", hidden: ["list"], disabled_by_column:true },
    { key: "private_flag", type: "boolean", hidden: ["list"], disabled_by_column:true },
    { key: "ac_flag", type: "boolean", hidden: ["list"], disabled_by_column:true },
    { key: "dc_flag", type: "boolean", hidden: ["list"], disabled_by_column:true },
    { key: "mac_addr", hidden: ["list","write"], disabled_by_column:true },
    { key: "port", hidden: ["list","write"], disabled_by_column:true },
    { key: "remark", row: 3, hidden: ["list"], disabled_by_column:true },
    { key: "freecharge_flag", type: "boolean", hidden: ["list"], disabled_by_column:true },
    { key: "cp_config_list", type: "component", component: CpConfigList, hidden: ["list", "create"], privilege: ["READ_CP_CONFIG"], disabled_by_column:true },
    // { key: "change_availability", type: "componentColumn", component: ChangeAvailability, hidden: ["create"], privilege: ["READ_CHANGE_AVAILABILITY"],width: 75, disabled_by_column:true },
    { key: "min_power_threshold", hidden: ["list"],  privilege: ["READ_ALERT"], disabled_by_column:true },
    { key: "cp_connectors" ,type:"cpConnector", hidden: ["list", "create"], privilege: ["READ_CP_CONNECTOR"], disabled_by_column:true},
    { key: "double_use_flag", type: "boolean", disabled_by_column:true},
    // { type: "action-btn", width: 125 },
    { key: "enable_flag", type: "boolean", width: 70 },
    { type: "action-btn", width: 125 },

  ],
  structure: [
    ["cp_no","name_chi"],
    ["loc_id"],
    ["enable_flag"],
    ["min_power_threshold"],
    ["remark"],
      ["cp_type"],
    ["charger_type"],
      ["double_use_flag"],
    ["cp_connectors"],
  ],
  cp_structure:[
    {key: "cp_config_id", disable: true, width: 75},
    {key: "cp_id", disable: true, width: 50},
    {key: "ip_address", disable: true},
    {key: "mac_address", disable: true},
    {key: "current", type: "boolean", width: 50 },
    {key: "pending", type: "boolean", width: 50},
    {key: "update_time", type: "datetime", width: "150px"},
    // {key: "config_json", disable: true },
    // {key: "hash_md5", disable: true },
    {key: "description"},
    {key: "fw_ver", disable: true},
    {key: "action_button", type: "action-btn", width: "125px"},
  ],
  action: ["create","edit","view","delete"],
  default: {
    max_power_output: "32",
    heartbeat_interval: "30",
    enable_flag: 1
  },
  options: {
    loc_id: {
      key: "cp_locs",
      label: "address",
      value: "loc_id"
    },
    loc_address: {
      key: "cp_locs",
      label: "address",
      value: "loc_id"
    },
    charging_status: {
      key: "charging_statuses",
      label: "name_chi",
      value: "charging_status_code"
    },
    connectora_status: {
      key: "charging_statuses",
      label: "name_chi",
      value: "charging_status_code"
    },
    connectorb_status: {
      key: "charging_statuses",
      label: "name_chi",
      value: "charging_status_code"
    },
    power_meter_type_id: {
      key: "cp_power_meter",
      label: "name",
      value: "power_meter_type_id"
    },
    charging_status_code: {
      key: "charging_statuses",
      label: "name_chi",
      value: "charging_status_code"
    },
    cp_no: {
      key: "cps",
      label: "cp_no",
      value: "cp_no"
    }
  },
  view: [
    ["cp_no","name_chi"],
    [{ key: "loc_id", value: "loc_id.address" }],
    ["enable_flag"],
    ["min_power_threshold"],
    ["remark"],
  ],
  extra_components: {
    view: [
      ChartByConnector,
    ],
  },
  disabled_by_column:{
    edit:[
      {key:"enable_flag", val:1, type:"eq"}
    ]
  },
  extra_privillege_components: {
    view: [
      {component: RsrStartCharger, privilege: ["READ_REMOTE_START_CHARGER"]},
      {component: RsrStopCharger, privilege: ["READ_REMOTE_START_CHARGER"]},
      {component: UnlockCharger, privilege: ["READ_REMOTE_START_CHARGER"]},
      {component: RsrResetCharger, privilege: ["READ_REMOTE_RESET_CHARGER"]},
      {component: GetDiagnostics, privilege: ["READ_GET_GIAGNOSTICS"]},
      {component: ChangeAvailability, privilege: ["READ_CHANGE_AVAILABILITY"]},
      {component: BaseButton, privilege: ["READ_TRIGGER_MESSAGE"], label:"trigger_message", url:"/cps/triggerMessage"},
    ],
  },
}
